// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_r5-0";